import React, {MouseEvent} from "react";

export interface ButtonProps {
    text: JSX.Element | string;
    onClick: (event: MouseEvent) => void;
    className?: string;
}

/**
 * A class representing a button that can do a thing when it's clicked on
 */
export class Button extends React.Component<ButtonProps, {}>{

    // constructor(props: ButtonProps) {
    //     super(props);
    // }


    render() {

        const classNameString=this.props.className ? this.props.className : "";

        return (<div
            onClick={this.props.onClick}
            className={`Button ${classNameString}`}>
            {this.props.text}
        </div>)
    }
}
